var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"project-card",style:({ height: _vm.height }),attrs:{"to":{ path: `/projects/${_vm.id}` },"tag":"div"}},[_c('div',{staticClass:"image"},[_c('app-image',{attrs:{"id":_vm.image,"name":_vm.title}})],1),_c('div',{staticClass:"project-title"},[_c('h5',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }